import { Subscription } from 'rxjs';

export class EnpsSubscriber {
    public subscriptions: Subscription = new Subscription();

    public createSubscription(prop: any, func: (param) => void) {
        if (this.subscriptions) {
            const sub: Subscription = prop.subscribe(func);
            this.subscriptions.add(sub);
            return sub;
        }
    }

    public removeAllSubscriptions() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        this.subscriptions = new Subscription();
    }
}
